var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMonitorNewTest = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 2V8C13.9999 8.33548 14.0841 8.66561 14.245 8.96L19.755 19.04C19.9217 19.3446 20.0062 19.6874 20.0002 20.0345C19.9942 20.3817 19.8979 20.7213 19.7208 21.02C19.5437 21.3187 19.2919 21.5661 18.9902 21.7379C18.6885 21.9098 18.3472 22.0001 18 22H6C5.65278 22.0001 5.31152 21.9098 5.00979 21.7379C4.70807 21.5661 4.45628 21.3187 4.27919 21.02C4.10211 20.7213 4.00583 20.3817 3.99984 20.0345C3.99384 19.6874 4.07833 19.3446 4.245 19.04L9.755 8.96C9.91589 8.66561 10.0001 8.33548 10 8V2",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.453 15H17.547",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 2H15.5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 6C20.6989 6 20.8896 6.07907 21.0303 6.21973C21.1709 6.36038 21.25 6.55109 21.25 6.75V7.75H22.25C22.4489 7.75 22.6396 7.82907 22.7803 7.96973C22.9209 8.11038 23 8.30109 23 8.5C23 8.69891 22.9209 8.88962 22.7803 9.03027C22.6396 9.17093 22.4489 9.25 22.25 9.25H21.25V10.25C21.25 10.4489 21.1709 10.6396 21.0303 10.7803C20.8896 10.9209 20.6989 11 20.5 11C20.3011 11 20.1104 10.9209 19.9697 10.7803C19.8291 10.6396 19.75 10.4489 19.75 10.25V9.25H18.75C18.5511 9.25 18.3604 9.17093 18.2197 9.03027C18.0791 8.88962 18 8.69891 18 8.5C18 8.30109 18.0791 8.11038 18.2197 7.96973C18.3604 7.82907 18.5511 7.75 18.75 7.75H19.75V6.75C19.75 6.55109 19.8291 6.36038 19.9697 6.21973C20.1104 6.07907 20.3011 6 20.5 6Z",
  fill: "currentColor"
})));
export default SvgMonitorNewTest;